export const getIdForDropdownButton = (dropdownId) => {
    return `${dropdownId}-button`;
};
export const getIdForDropdownList = (dropdownId) => {
    return `${dropdownId}-list`;
};
export const getIdForDropdownListItem = (dropdownId, option) => {
    return `${dropdownId}-list-item-${option.value}`;
};
export const sortDropdownOptionsAlphabetically = (optionA, optionB) => {
    return optionA.text.localeCompare(optionB.text);
};
